<template>
	<div class="col-4- mb-2- mt-4- position-relative">
		<router-link :to="{ name: 'Gallery', params: { id: id } }">
			<div :class="{ 'overlay-items' : Overlay }" class="museum-galerij-button mx-auto">
				<div class="h-100 d-flex museum-button-bg-img" :style="style">
					<div class="h-100 w-100 museum-galerij-button-text-bg">
						<div class="h-100 d-flex">
							<h1 class="m-auto text-center">{{ title }}</h1>
						</div>
					</div>
				</div>
				<span v-if="Overlay" class="hand-icon hand-left"></span>
			</div>
			<span class="icon gallery-btn"></span>
			<h1 class="photo-amount">{{ total }} <span v-if="total > 1">{{ t('gallery_text.multiple_photos') }}</span><span v-else>{{ t('gallery_text.single_photo') }}</span></h1>
		</router-link>
		<h1 v-if="Overlay" class="overlay-text">{{ t('overlay.open_gallery') }}</h1>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
	name: "GalleryOverviewItem",
	props: {
		title: String,
		image: String,
		id: Number,
		total: Number,
		Overlay: Boolean
	},
	computed: {
		style() {
			return `background-image: url('${this.image}')`;
		}
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
};
</script>

<style scoped>
.overlay-items {
	position: relative;
	z-index: var(--global-z-index-overlay-items);
	transform: scale(1);
	animation: pulse-gallery-item 2.5s infinite linear;
	box-shadow: 0 0 10px 5px #fff;
}

.hand-icon {
	position: relative;
	z-index: var(--global-z-index-overlay-info);
	background-image: url("~@/assets/img/icons/touch-me.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 150px;
	width: 100px;
}

.overlay-text {
	position: absolute;
	left: 0;
	right: 0;
	bottom: -50px;
	text-align: center;
	color: #fff;
	z-index: var(--global-z-index-overlay-info);
}

.photo-amount {
	margin-top: 14px;
	text-align: center;
	color: #fff;
	font-size: 26px;
	font-weight: bold;
}

.icon {
	--size:  54px;
	z-index: 1;
	position: absolute;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: var(--size);
	width: var(--size);
	right: 10px;
	top: 10px;
}

.gallery-btn {
	background-image: url("~@/assets/img/icons/photo-gallery.svg");
}

.hand-left {
    position: absolute;
    left: 150px;
    bottom: -50px;
}

@keyframes pulse-gallery-item {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.01);
    }
    100% {
        transform: scale(1);
    }
}
</style>